import { useSnapshot, useSendCommand, useStation } from '../state/TelephonyProvider'
import { TelephonyCommandNames } from '../contract'
import { prettyNumber } from './_shared'
import { IconArrowBackUp } from '../ui/icons'

export function ParkedCallsPanel() {
  const { parked } = useSnapshot()
  const send = useSendCommand()
  const station = useStation()
  return (
    <div className="sb-panel">
      {parked.length === 0 ? (
        <div className="sb-panel-empty">No parked calls.</div>
      ) : (
        parked.map((p) => (
          <div key={p.parkingSpace} className="list-row row">
            <span>
              <strong>{p.parkingSpace}</strong> · {p.callerIdName || prettyNumber(p.callerIdNumber) || 'unknown'}
              <span className="faint"> (by {p.parkerExtension})</span>
            </span>
            <button className="btn" title="retrieve to your extension"
              onClick={() => void send({
                command: TelephonyCommandNames.Unpark,
                params: { parking_space: p.parkingSpace, to_extension: station.extension }
              })}>
              <IconArrowBackUp size={14} stroke={1.75} /> retrieve
            </button>
          </div>
        ))
      )}
    </div>
  )
}
